import { useDispatch }               from 'react-redux';
import { useEffect }                 from 'react';
import { pageAppear, pageDisappear } from 'Redux/Action';

export const useAppearPage = (page) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(pageAppear(page));

        return () => {
            dispatch(pageDisappear(page))
        }
    }, [dispatch]);
}